"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnackbar = void 0;
const notistack_1 = require("notistack");
const snackbarUtils_1 = require("./snackbarUtils");
const useSnackbar = () => {
    const { enqueueSnackbar, closeSnackbar } = (0, notistack_1.useSnackbar)();
    const enqueue = (options) => {
        const mappedOptions = (0, snackbarUtils_1.addDefaultSnackbarOptions)(options);
        if (mappedOptions.variant === "error") {
            const { message, contactUs, actionButton, title, ...rest } = mappedOptions;
            enqueueSnackbar(message, {
                ...rest,
                content: (key) => (0, snackbarUtils_1.mapOptionsToSnackbar)({
                    ...rest,
                    title,
                    contactUs,
                    actionButton,
                    message,
                }, () => closeSnackbar(key)),
            });
        }
        else {
            const { message, actionButton, ...rest } = mappedOptions;
            enqueueSnackbar(message, {
                ...rest,
                content: (key) => (0, snackbarUtils_1.mapOptionsToSnackbar)({
                    ...rest,
                    actionButton,
                    message,
                }, () => closeSnackbar(key)),
            });
        }
    };
    return {
        enqueue,
        closeSnackbar,
    };
};
exports.useSnackbar = useSnackbar;
